import { createSlice } from '@reduxjs/toolkit';
// TODO: change once auth is properly setup
const initialState = {
  email: '',
  portalId: ''
};
const billingPortalSlice = createSlice({
  name: 'billingPortal',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setPortalId: (state, action) => {
      state.portalId = action.payload;
    }
  }
});
export const getEmail = state => state.billingPortal.email;
export const getPortalId = state => state.billingPortal.portalId;
export const {
  setEmail,
  setPortalId
} = billingPortalSlice.actions;
export default billingPortalSlice.reducer;